<template>
  <div class="hero">
    <h2 id="headertext" class="has-text-centered">{{ $t('hero.TITLE') }}</h2>
    <form class="hero_search-form margin-top-bigger"
          role="search"
          method="get"
          action="/search"
          v-on:submit.prevent="onSubmit">
      <div class="centered-search-box">
        <div class="field has-addons">
          <div class="control input-field">
            <input required="required"
                aria-labelledby="headertext"
                class="input"
                type="search"
                name="q"
                :placeholder="$t('hero.PLACEHOLDER')"
                autocapitalize="none"
                id="searchTerm"
                v-model.lazy="form.searchTerm" />
          </div>
          <div class="control">
            <button class="button is-primary" title="Search" style="background-color: #d43c12;">{{ $t('SEARCH') }}</button>
          </div>
        </div>
      </div>
      <div class="caption has-text-centered margin-top-big">
        <p>
          {{ $t('hero.LICENSE_STATEMENT') }} {{ $t('hero.CAPTION_BEFORE_LINK') }}
          <a href="https://creativecommons.org/share-your-work/licensing-examples/" target="_blank" rel="noopener" style="color: #d43c12;">{{ $t('hero.CAPTION_LINK') }}</a>
          {{ $t('hero.CAPTION_AFTER_LINK') }}
        </p>
      </div>
      <home-license-filter />
    </form>
    <div class="help-links is-hidden-mobile">
      <span class="margin-right-bigger">
        {{ $t('hero.help.CAPTION_BEFORE_LINK') }}
        <a href="https://oldsearch.creativecommons.org/" style="color: #d43c12;">{{ $t('hero.help.CAPTION_LINK') }}</a> {{ $t('hero.help.CAPTION_AFTER_LINK') }}
      </span>
    </div>
    <locale-changer />
  </div>
</template>

<script>
import { SET_QUERY } from '@/store/mutation-types';
import HomeLicenseFilter from './HomeLicenseFilter';
import LocaleChanger from './LocaleChanger';


export default {
  name: 'hero-section',
  components: {
    HomeLicenseFilter,
    LocaleChanger
  },
  data: () => ({ form: { searchTerm: '' } }),
  methods: {
    onSubmit() {
      this.$store.commit(SET_QUERY, { query: { q: this.form.searchTerm }, shouldNavigate: true });
    },
  },
};
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "node_modules/bulma/sass/utilities/initial-variables";
@import "node_modules/bulma/sass/utilities/derived-variables";
@import "node_modules/bulma/sass/utilities/mixins";
@import "node_modules/@creativecommons/vocabulary/scss/spacing";

$hero-height: 74vh;

.hero {
  background: #fff;
  position: relative;
  height: $hero-height;
  background-size: cover;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  min-height: 300px;

  .hero_search-form {
    position: relative;
    max-width: 750px;
    width: 100%;
    padding: 0 0.5em 0 0.5em;
  }

  .centered-search-box {
    justify-content: center;

    @media screen and (max-width: $tablet - 1px) {
      .input-field {
        width: 100%;
      }
      .button {
        font-size: 1rem;
        padding: $space-small calc(#{$space-normal} + .2rem);
      }
    }

    @media screen and (min-width: $tablet) {
      .input-field {
        input {
          width: 570px;
          font-size: 1.75rem;
          height: 5.063rem;
          padding-left: $space-big;
        }
      }
      .button {
        font-size: 1.75rem;
        padding: calc(#{$space-large} - .093rem) $space-large;
      }
    }
  }


  /* Small only */
  @include mobile {
    height: 80vh;
  }
}

.help-links {
  position: absolute;
  bottom: 1rem;
  left: 1rem;
}

.help-icon {
  height: 32px;
  vertical-align: middle;
}

.locale-changer {
  position: absolute;
  bottom: 1rem;
  right: 1rem;
}
</style>
